import md5 from 'blueimp-md5'
import { md5Config } from '../../webconfig'

/*
 * 重写 console.log
 * */
export const log = function(obj) {
  if (typeof obj === 'object') {
    console.log(JSON.parse(JSON.stringify(obj)))
  } else {
    console.log(obj)
  }
}

export const MD5 = val => {
  val = md5Config.prefix + val + md5Config.suffix
  return md5(val)
}

/*
 * 存储 SessionStorage
 * */
export const SetSessionStore = (name, content) => {
  if (!name) {
    return
  }
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取 SessionStorage
 */
export const GetSessionStore = name => {
  if (!name) {
    return
  }
  let s = window.localStorage.getItem(name)
  return s
}
/**
 * 删除 SessionStorage
 */
export const RemoveSessionStore = name => {
  if (!name) {
    return
  }
  window.localStorage.removeItem(name)
}

/**
 * 存储localStorage
 */
export const SetStore = (name, content) => {
  if (!name) {
    return
  }
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const GetStore = name => {
  if (!name) {
    return
  }
  let s = window.localStorage.getItem(name)
  return s
}

/**
 * 删除localStorage
 */
export const RemoveStore = name => {
  if (!name) {
    return
  }
  window.localStorage.removeItem(name)
}

/**
 * 删除localStorage
 */
export const RemoveALL = () => {
  localStorage.clear()
  sessionStorage.clear()
}
export const findById = idName => {
  if (!idName) {
    console.log('没有ID名称')
    return
  }
  return document.getElementById(idName)
}
export const findClassName = className => {
  if (!className) {
    console.log('没有className名称')
    return
  }
  return document.getElementsByClassName(className)
}
export const querySelector = selectName => {
  if (!selectName) {
    console.log('没有querySelector查询参数')
    return
  }
  return document.querySelector(selectName)
}
export const trimStr = str => {
  if (!str) {
    console.log('没有需要转换参数')
    return
  }
  return str.replace(/(^\s*)|(\s*$)/g, '')
}
export const RegExpr = {
  /**
   * 校验手机号
   * @param mobile
   * @returns {boolean}
   */
  checkMobile: mobile => {
    return /^[1][0-9]{10}$/.test(mobile)
  },

  /**
   * 校验纯数字
   * @param num
   * @returns {boolean}
   */
  checkNum: num => {
    return /^[0-9]+$/.test(num)
  },

  /**
   * 校验用户名：1-20位字符，首字符为字母
   * @param str
   * @returns {RegExp}
   */
  checkUserName: str => {
    return /^[a-zA-Z]{1,20}$/.test(str)
  },

  /**
   * 校验密码：6-20位，数字、字母、下划线
   * @param str
   * @returns {boolean}
   */
  checkPwd: str => {
    return /^(\\w){6,20}$/.test(str)
  },

  /**
   * 校验正整数 + 0
   * @param num
   * @returns {boolean}
   */
  checkPositiveInteger: num => {
    return /^[0-9]*[1-9][0-9]*$/.test(num)
  }
}

/* JS 模拟Post或Get方法打开新窗口
 *
 * 使用访求post('pages.html', {money:'400',bankName:'ABC'})
 * */
export const PostForm = (
  url: string,
  params: object = {},
  post: string = 'post'
) => {
  let postForm = document.createElement('form')
  postForm.action = url
  postForm.method = post
  postForm.target = 'blank'
  postForm.style.display = 'none'
  for (let x in params) {
    let opt = document.createElement('input')
    opt.name = x
    opt.value = params[x]
    postForm.appendChild(opt)
  }
  document.body.appendChild(postForm)
  postForm.submit()
  return postForm
}

// Base64 加密
export const Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  _utf8_encode(string) {
    string = string.replace(/\r\n/g, '\n')
    let utftext = ''
    for (let n = 0; n < string.length; n++) {
      let c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  },
  encode(input) {
    let _keyStr =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    if (!input) return
    if (typeof input === 'object') {
      input = JSON.stringify(input)
    }
    let output = ''
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4
    let i = 0
    input = this._utf8_encode(input)
    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output =
        output +
        _keyStr.charAt(enc1) +
        _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) +
        _keyStr.charAt(enc4)
    }
    console.log()
    return output
  },
  decode(input) {
    console.log(this._keyStr)

    let _keyStr =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    let output = ''
    let chr1, chr2, chr3
    let enc1, enc2, enc3, enc4
    let i = 0
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++))
      enc2 = _keyStr.indexOf(input.charAt(i++))
      enc3 = _keyStr.indexOf(input.charAt(i++))
      enc4 = _keyStr.indexOf(input.charAt(i++))
      chr1 = (enc1 << 2) | (enc2 >> 4)
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      chr3 = ((enc3 & 3) << 6) | enc4
      output = output + String.fromCharCode(chr1)
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3)
      }
      chr1 = chr2 = chr3 = ''
      enc1 = enc2 = enc3 = enc4 = ''
    }
    output = this._utf8_encode(output)
    return output
  }
}
//// Cookies

export const Cookies = {
  setCookie(name, value, expiredays) {
    let cookieValue
    if (typeof value === 'object') {
      cookieValue = JSON.stringify(value)
    } else {
      cookieValue = value
    }
    const data = new Date()
    let et = expiredays
      ? parseFloat(expiredays) * 1000 * 60
      : 1000 * 60 * 60 * 24 * 1 //默认一天
    data.setTime(data.getTime() + Number(et))
    document.cookie = `${name}=${encodeURIComponent(cookieValue)}${
      expiredays == null ? '' : `;expires=${data.toUTCString()}`
    };path=/`
  },
  getCookie(name) {
    if (document.cookie.length > 0) {
      let startIndex = document.cookie.indexOf(`${name}=`)
      if (startIndex !== -1) {
        startIndex = startIndex + name.length + 1
        let endIndex = document.cookie.indexOf(';', startIndex)
        if (endIndex === -1) {
          endIndex = document.cookie.length
        }
        return decodeURIComponent(
          document.cookie.substring(startIndex, endIndex)
        )
      }
    }
    return null
  },
  delCookie(name) {
    const exp = new Date()
    exp.setTime(exp.getTime() - 1)
    document.cookie = `${name}=0;expires=${new Date(0).toUTCString()}`
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/services/comment.ts